// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getOtherDataContacts as listOtherDataContactsAPI,
    getOtherDataContact as getOtherDataContactAPI,
    addOtherDataContact as addOtherDataContactAPI,
    updateOtherDataContact as updateOtherDataContactAPI,
    deleteOtherDataContact as deleteOtherDataContactAPI,
} from '../../helpers/';

import { otherDataContactsApiResponseError, otherDataContactsApiResponseSuccess } from './actions';
import { OtherDataContactsActionTypes } from './constants';

function* getOtherDataContact({ payload: { id } }) {
    try {
        const response = yield call(getOtherDataContactAPI, id);
        const otherDataContactoItem = response.data.data;
        yield put(otherDataContactsApiResponseSuccess(OtherDataContactsActionTypes.GET_OTHER_DATA_CONTACTS, otherDataContactoItem));
    } catch (error) {
        yield put(otherDataContactsApiResponseError(OtherDataContactsActionTypes.GET_OTHER_DATA_CONTACTS, error));
    }
}

function* addOtherDataContact({ payload: otherDataContacto }) {
    try {
        const response = yield call(addOtherDataContactAPI, { ...otherDataContacto })
        const otherDataContactoItem = response.data
        yield put(otherDataContactsApiResponseSuccess(OtherDataContactsActionTypes.ADD_OTHER_DATA_CONTACTS, otherDataContactoItem))
    } catch (error) {
        yield put(otherDataContactsApiResponseError(OtherDataContactsActionTypes.ADD_OTHER_DATA_CONTACTS, error))
    }
}

function* updateOtherDataContact({ payload: otherDataContacto }) {
    try {
        const response = yield call(updateOtherDataContactAPI, { ...otherDataContacto })
        const otherDataContactoItem = response.data.data
        yield put(otherDataContactsApiResponseSuccess(OtherDataContactsActionTypes.UPDATE_OTHER_DATA_CONTACTS, otherDataContactoItem))
    } catch (error) {
        yield put(otherDataContactsApiResponseError(OtherDataContactsActionTypes.UPDATE_OTHER_DATA_CONTACTS, error))
    }
}
function* deleteOtherDataContact({ payload: { id } }) {
    try {
        const response = yield call(deleteOtherDataContactAPI, id)
        const otherDataContactoItem = response.data.id
        yield put(otherDataContactsApiResponseSuccess(OtherDataContactsActionTypes.DELETE_OTHER_DATA_CONTACTS, otherDataContactoItem))
    } catch (error) {
        yield put(otherDataContactsApiResponseError(OtherDataContactsActionTypes.DELETE_OTHER_DATA_CONTACTS, error))
    }
}

/**
 * List contactos
 */
function* listOtherDataContacts({ payload: params }) {
    try {
        const response = yield call(listOtherDataContactsAPI, { ...params });
        const listaOtherDataContacts = response.data.data;
        yield put(otherDataContactsApiResponseSuccess(OtherDataContactsActionTypes.LIST_OTHER_DATA_CONTACTS, listaOtherDataContacts));
    } catch (error) {
        yield put(otherDataContactsApiResponseError(OtherDataContactsActionTypes.LIST_OTHER_DATA_CONTACTS, error));
    }
}


export function* watchGetOtherDataContact(): any {
    yield takeEvery(OtherDataContactsActionTypes.GET_OTHER_DATA_CONTACTS, getOtherDataContact);
}

export function* watchListOtherDataContacts(): any {
    yield takeEvery(OtherDataContactsActionTypes.LIST_OTHER_DATA_CONTACTS, listOtherDataContacts);
}

export function* watchAddOtherDataContact(): any {
    yield takeEvery(OtherDataContactsActionTypes.ADD_OTHER_DATA_CONTACTS, addOtherDataContact)
}
export function* watchUpdateOtherDataContact(): any {
    yield takeEvery(OtherDataContactsActionTypes.UPDATE_OTHER_DATA_CONTACTS, updateOtherDataContact)
}
export function* watchDeleteOtherDataContact(): any {
    yield takeEvery(OtherDataContactsActionTypes.DELETE_OTHER_DATA_CONTACTS, deleteOtherDataContact)
}


function* otherDataContactsSaga(): any {
    yield all([
        fork(watchGetOtherDataContact),
        fork(watchListOtherDataContacts),
        fork(watchAddOtherDataContact),
        fork(watchUpdateOtherDataContact),
        fork(watchDeleteOtherDataContact),
    ]);
}

export default otherDataContactsSaga;
